import React, {Fragment, useRef, useState} from 'react' ;

import { renderField, validateField } from "./autoformStandardRenderers";

import SpinnerDiv from "../Components/SpinnerDiv";

import './useAutoForm.scss';
import "react-toggle/style.css"

const useAutoForm = ( forceRenderForm ) =>
{
    const [ formFields, setFormFields ]  = useState({});
    const formValidation = useRef({});
    const formDefinition = useRef({});
    const [ isInitialised, setInitialised ] = useState ( false ) ;
    const [ displayMode, setDisplayMode ] = useState ( 'create' ) ;

    const [displayErrors, setDisplayErrors] = useState(false);

    const enableDisplayErrors = ( value ) =>
    {
        setDisplayErrors ( value ) ;
        forceRenderForm() ;
    }

    const dateToDMY = (date) =>
    {
        const d = date.getDate();
        const m = date.getMonth() + 1;
        const y = date.getFullYear();

        return '' + (d <= 9 ? '0' + d : d) + '/' + (m<=9 ? '0' + m : m) + '/' + y ;
    }

    const getFieldValue = (name, final) =>
    {
        if (formFields[name] !== undefined)
        {
            if ( final === true )
            {
                let value = formFields[name].value ;

                if ( formFields[name]['definition']['field_type'] === 'date')
                {
                    if ( value instanceof Date )
                    {
                        value = dateToDMY ( value ) ;
                    }
                }

                return value ;
            }
            else
            {
            return (formFields[name].value)
        }
        }
        else
        {
            return null;
        }
    }

    const isFieldDirty = (name) =>
    {
        if (formFields[name] !== undefined)
        {
            return formFields[name].dirty ;
        }
        else
        {
            return false;
        }
    }

    const areFieldsDirty = () =>
    {
        return formFields.reduce((cur, rec) =>
        {
            return rec.dirty === true || cur === true ? true : cur;
        }, false);
    }

    const setFieldValue = (name, value, init) =>
    {
        const firstTime = !(init === undefined || init === null);
        let fFields = formFields;

        const valid = firstTime ? true : validateField ( formFields[name].definition, value );

        fFields[name] = {dirty: true, value: value, valid: valid, definition: fFields[name].definition };

        if (formFields[name]['definition']['dependencies'] !== undefined )
        {
            const deps = formFields[name]['definition']['dependencies'] ;

            for ( let curDep = 0 ; curDep < deps.length ; curDep++ )
            {
                const dep = formFields[name]['definition']['dependencies'][curDep];

                const fieldName = dep.field;
                const actions = dep.actions;

                for (let act = 0; act < actions.length; act++)
                {
                    const curaction = actions[act];

                    if (curaction['value'] === value)
                    {
                        console.log("Matching action ");

                        const attrib = curaction.action.attrib;
                        const attribValue = curaction.action.value;

                        for (let def = 0; def < formDefinition.current.length; def++)
                        {
                            const curdef = formDefinition.current[def];

                            if (curdef.ref === fieldName)
                            {
                                formDefinition.current[def][attrib] = attribValue;
                            }
                        }
                    }
                }
            }
        }

        setFormFields(fFields);

        if (!firstTime)
        {
            // If we're changing the value, set the form status to changed
            forceRenderForm();
        }
    }

    const getFormData = () =>
    {
        let items = [] ;

        for (let key in formDefinition.current)
        {
            const cur = formDefinition.current[key] ;

            if ( isFieldDirty(cur.ref))
            {
                let obj = {} ;

                obj.ref = cur.ref ;
                obj.field_type = cur.field_type ;
                obj.data_type = cur.data_type ;
                obj.item_name = cur.item_name ;
                obj.params = cur.params ;

                obj.value = getFieldValue( cur.ref, true )  ;

                items.push (obj) ;
            }
        }

        return items;
    }

    const isFieldValid = (fieldRef) =>
    {
        return validateField ( formFields[fieldRef].definition, getFieldValue( fieldRef ) )
    }

    const isFormValid = () =>
    {
        let valid = true ;

        let curValidation = formFields;

        for (let key in formDefinition.current)
        {
            const cur = formDefinition.current[key] ;

            if ( !isFieldValid(cur.ref))
            {
                curValidation[cur.ref].valid = false ;
                valid = false ;
            }
            else
            {
                curValidation[cur.ref].valid = true ;
        }
        }

        setFormFields( curValidation ) ;

        return valid;
    }

    const handleOnChangeDropdown = (evt, options) =>
    {
        if ( options.action === 'select-option')
        {
            if ( Array.isArray(evt))
            {
                const value = evt.map ((item) => {
                    return item.value ;
                })

                setFieldValue(options.name, value);
            }
            else
            {
            const value = evt.value;

                setFieldValue(options.name, value);
            }
        }
        else if ( options.action === 'remove-value')
        {
            const value = evt.map ((item) => {
                return item.value ;
            })

            setFieldValue(options.name, value);
        }
        else if ( options.action === 'clear' )
        {
            const value = formDefinitionOriginal.current[options.name].value ;

            setFieldValue(options.name, value);
        }
    }

    const handleOnChangeUserInput = (evt) =>
    {
        const value = evt.target.value;
        const name = evt.target.name;

        setFieldValue(name, value);
    }

    const handleOnChangeUserInputDate = (name, evt) =>
    {
        setFieldValue(name, evt);
    }

    const handleOnChangeToggle = (evt) =>
    {
        const value = evt.target.checked === true ? 1 : 0 ;
        const name = evt.target.name ;

        setFieldValue ( name, value  ) ;
    }

    const handleOnChangeUserInputRadio = (evt) =>
    {
    }

    const getChangeHandlerForType = ( type ) =>
    {
        switch ( type )
        {
            case 'input' :
                return (handleOnChangeUserInput);
            case 'dropdown':
                return (handleOnChangeDropdown);
            case 'date':
                return (handleOnChangeUserInputDate);
            case 'toggle' :
                return (handleOnChangeToggle);
            default:
                throw new Error('No change handler available for input type "' + type + '"' );
        }
    }

    const shouldDisplayErrors = () =>
    {
        return displayErrors ;
    }

    const fieldHandlers = {
        getFieldValue: getFieldValue,
        isFieldValid: isFieldValid,
        getChangeHandlerForType: getChangeHandlerForType,
        shouldDisplayErrors: shouldDisplayErrors,
    }

    const getHandlerType = (fieldType) =>
    {
        switch (fieldType)
        {
            case 'input' :
                return 'input';
            case 'dropdown_family_type':
                return 'dropdown';
            default:
                return 'input';
        }
    }

    const initialise = (definition, mode) =>
    {
        return new Promise((resolve, reject) => {
            // Save the initial state for the lifetime
            formDefinition.current = definition;

            let initialState = {};
            let initialValidation = {};

            definition.forEach((item) =>
            {
                const defaultValid = ( item.field_type === 'header6' ||
                    item.field_type === 'header1' ||
                    item.field_type === 'toggle' ) ? true : true ;

                const initVal = item.value === null || item.value === undefined ? '' : item.value ;

                let isDirty = false ;

                if ( mode === 'create' && ( initVal !== '' && initVal != null ))
                {
                    // If we have a default value on create, then set the field dirty so it will be submitted
                    isDirty = true ;
                }

                const state = {
                    dirty: isDirty,
                    value: initVal,
                    valid: defaultValid,
                    definition: item
                }

                initialState[item.ref] = state;

                const validation = {
                    type: getHandlerType(item.field_type),
                    ...item.validation
                }

                initialValidation[item.ref] = validation;
            })

            setFormFields(initialState);
            formValidation.current = initialValidation;

            setDisplayMode ( mode ) ;
            setInitialised (true) ;

            resolve(true);
        });
    }

    const doRenderItem = (props, definition) =>
    {
        return ( renderField(props, definition, fieldHandlers));
    }

    const renderForm = ( props ) =>
    {
        let rval = <SpinnerDiv/> ;

        if ( Array.isArray(formDefinition.current))
        {
            let lineList = [] ;
            let cols = [] ;
            let rows = 0 ;
            let thisRowCols = 0 ;

            const items = formDefinition.current ;

            for ( let i in items )
            {
                let skipRender = false ;

                const thisItem = items[i] ;

                if ( thisItem?.metaData !== undefined )
                {
                    if ( thisItem?.metaData?.hideOnCreate === true && displayMode === 'create')
                    {
                        // Don't display this
                        skipRender = true ;
                    }
                }

                if ( thisItem?.visible === false )
                {
                    // Don't display this
                    skipRender = true ;
                }

                if ( skipRender === false )
                {
                let thisCellClassName = 'col-md-' + thisItem.colSpan ;

                const thisCell = <div className={thisCellClassName} key={'col' + thisItem.ref + thisItem.record_id}>{doRenderItem(props, thisItem)}</div>

                cols.push( thisCell ) ;

                thisRowCols += +thisItem.colSpan ;

                if ( thisRowCols >= 12 )
                {
                    const rowElement = <div className='row' key={'DynamicFormRow' + rows}>{cols}</div>

                    lineList.push( rowElement );
                    thisRowCols = 0 ;
                    rows++ ;
                    cols = [] ;
                }
                else if ( thisItem.lineBreak === true )
                {
                    let remainingCols = 12 - +thisRowCols ;

                    let className = 'col-md-' + remainingCols;

                    const fillerCol = <div className={className} key={'DynamicRowDiv' + rows }>&nbsp;</div>
                    cols.push( fillerCol ) ;

                    const rowElement = <div className='row' key={'DynamicFormRow' + rows}>{cols}</div>

                    lineList.push( rowElement );
                    thisRowCols = 0 ;
                    rows++ ;
                    cols = [] ;
                }
            }
            }

            if ( thisRowCols !== 0 )
            {
                let remainingCols = 12 - +thisRowCols ;

                let className = 'col-md-' + remainingCols;

                const fillerCol = <div className={className} key={'DynamicRowDiv' + rows }>&nbsp;</div>
                cols.push( fillerCol ) ;

                const rowElement = <div className='row' key={'DynamicFormRow' + rows}>{cols}</div>

                lineList.push( rowElement );
            }

            rval = lineList ;
        }

        return (
            <Fragment>
                <div className='autoform-wrapper'>{rval}</div>
            </Fragment>
        );
    }

    return [initialise, renderForm, isFormValid, getFormData, enableDisplayErrors, isInitialised];
}

export default useAutoForm;